<script>
  import ClosableModal from 'root/services/modals/Closable.modal.svelte';
  import SpinnerWithText from 'root/components/molecules/SpinnerWithText.svelte';
  import {mainAPI, httpErrorHandler} from 'root/angular-injector-provider';

  export let hide, bids;

  let errors;

  init();

  async function init() {
    try {
      const headers = await mainAPI().exportBidManagerToExcel(bids, 'HOTEL_RFP:GBTA_PRDS_AMEX:EXCEL');
      const errorsString = headers['rb-errors'];
      errors = errorsString && errorsString.length ? JSON.parse(errorsString): undefined;
      if (!errors || !errors.length) hide();
    } catch (error) {
      httpErrorHandler().handle(error);
      hide();
    }
  }

</script>

<ClosableModal width="480px">
  <div slot="heading" class="Heading">
    <div>PRDS Export</div>
  </div>

  <div>
    {#if errors}
      <div class="ErrorMessage">
        Export saved!<br />
        We were not able to export some final agreements:
      </div>

      <div class="ErrorsList">
        {#each errors as error}
          <div class="ErrorsItem">
            <div><b>{error.hotel}</b></div>
            <div>{error.message || 'Error not specified.'}</div>
          </div>
        {/each}
      </div>

      <div class="Actions">
        <button class="aBtn asLarge atLight asMain"
                on:click={hide}
        >
          Close
        </button>
      </div>
    {:else}
      <div class="Spinner">
        <SpinnerWithText>Creating PRDS file, please wait...</SpinnerWithText>
      </div>
    {/if}
  </div>

</ClosableModal>

<style lang="stylus">

  .Heading {
    font-size: 14px;
    color: #546E7A;
    font-weight: bold;
    padding: 15px;
  }

  .ErrorMessage {
    font-size: 13px;
    color: #F15A24;
    font-weight: bold;
    padding: 5px 15px;
  }

  .ErrorsList {
    overflow: auto;
    max-height: 40vh;
    font-size: 12px;
    line-height: 16px;
    color: #78909C;
  }

  .ErrorsItem {
    padding: 5px 20px;
  }

  .Spinner {
    padding-bottom: 20px;
  }

  .Actions {
    display: flex;
    justify-content: flex-end;
    padding: 20px 15px;
  }

</style>
